app.CertifiedCandidateSearch = (
    function () {
        var search = {
            Index: function () {
                $("#btnResetForm").on("click", function () {
                    // reset all form fields
                    $("#SelectedPositionType").val("");
                    $("#HighestDegree_Any").prop("checked", true);
                    $("#DateFilter").val("");
                    $(".autocomplete-container > input").val("");
                    $("#LastModified_All").prop("checked", true);
                    $("#MyCesaRegionOnly").prop("checked", false);
                    $("#MinimumYearsTeachingExperience").val("");
                    $("#MinimumYearsAdministratorExperience").val("");
                    $("#FirstNameFilter").val("");
                    $("#LastNameFilter").val("");
                    app.input.resetSelectManys($("#btnResetForm").closest('form'));

                    // Clear last sort field so that the sort doesnt persist when resetting filters
                    $("input[Name='LastSortField']").val(null);
                    // Remove all sort stuff before the post
                    $("a[data-role='sort-action']").removeClass("desc");
                    $("a[data-role='sort-action']").removeClass("asc");
                    $("a[data-role='sort-action']").removeAttr("aria-sort");
                    $("a[data-role='sort-action']").removeData("role");

                    app.page.components["CertifiedCandidateGrid"][0].refreshGrid();
                });
            }
        };

        return search;
    }()
);